import { rankingData } from '@/mocks/homepage';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-secondary-500',
  down: 'ri-arrow-down-line text-foreground-400',
  stable: 'ri-subtract-line text-accent-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            人气排行
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            综合热度、评分与讨论量的实时漫画排行榜
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-100 rounded-xl overflow-hidden">
          {rankingData.map((item, index) => (
            <a
              key={item.rank}
              href="#index"
              className={`flex items-center gap-4 px-5 md:px-6 py-4 hover:bg-background-200/50 transition-colors duration-200 cursor-pointer no-underline ${
                index < rankingData.length - 1 ? 'border-b border-background-300/40' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-accent-300 text-foreground-900'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <span className="font-medium text-sm text-foreground-900 whitespace-nowrap">
                    {item.title}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {item.type}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-0.5">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {item.hot}
                  </span>
                  <span>{item.desc}</span>
                </div>
              </div>
              <div className="flex items-center gap-1 flex-shrink-0">
                <i className={trendIcons[item.trend] || ''}></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}